<script lang="ts">
  import { SelectProvider } from '../use-select-context';
  import { useSelect } from '../use-select.svelte';
  import { selectStyles } from '../select.styles';
  import type { SelectRootProps } from '../select.types';

  const { children, items, ...props }: SelectRootProps = $props();

  const id = $props.id();
  const select = useSelect(items, { ...props, id });
  SelectProvider(select);

  export const clearAll = () => select.api.clearValue();
  export const selectValue = (key: string) => select.api.selectValue(key);
  export const unselectValue = (key: string) => select.api.clearValue(key);

  const classes = selectStyles();
</script>

<div {...select.api.getRootProps()} class={classes.root}>
  {#if children}
    {@render children()}
  {/if}
</div>
